'use client';

import React from 'react';

import type { MenuParserData, MenuParserDataWithPartialMenuData, MenuTemplates } from '../../types/menus';
import DefaultMenu from './default-menu/DefaultMenu';
import SearchOrientedMenu from './search-oriented-menu/SearchOrientedMenu';

const menuTemplates: Record<MenuTemplates, React.ComponentType<MenuParserData>> = {
  default: DefaultMenu,
  'search-oriented': SearchOrientedMenu,
};

export const MenuParser = (props: MenuParserDataWithPartialMenuData) => {
  const { menuData } = props;
  if (!menuData) {
    return null;
  }

  const MenuComponent = menuTemplates[menuData.template];
  if (!MenuComponent) return null;

  return <MenuComponent {...props} menuData={menuData} />;
};
